<template>
  <nav id="nav" :class="['nav', {'condensed' : navCondensed}]" @mouseleave="taglineVisible = false" @mouseenter="navCondensed = false">
    <div class="nav__mobile-header">
      <button id="navToggleBtn" @click="mobileNavVisible = !mobileNavVisible">
        <span class="icon icon--menu" v-show="!mobileNavVisible"></span>
        <span class="icon icon--close" v-show="mobileNavVisible"></span>
      </button>
      <router-link title="Home" :to="{name: 'Intro'}" class="home-link"><logo></logo></router-link>
      <div></div>
    </div>
    <!-- pages -->
    <transition name="fadeinplace">
      <ul v-show="!taglineVisible" :class="{'nav__pages--hidden': !mobileNavVisible}">
        <div class="home-link-outer">
          <router-link title="Home" :to="{name: 'Intro'}" class="home-link">
            <div @mouseenter="taglineVisible = true">
              <logo></logo>
            </div>
          </router-link>
        </div>
        <li>
          <button @click="collectionsVisible = !collectionsVisible" :class="{'submenu-toggle--hidden': collectionsVisible}">
            <!-- <span>Purchase</span> -->
            <router-link :to="{name: 'Purchase'}"><span>Purchase</span></router-link>
          </button>
          <ul :class="{'submenu--visible': collectionsVisible}">
            <li>
              <router-link to="/collections/bespoke-service">
                <span>Our Bespoke Service</span>
              </router-link>
            </li>
            <li v-for="collection in collections" :key="collection.id" v-if="collection.data['collection.visible'].value !== 'false' && collection.data['collection.number'].value">
              <router-link :to="{name: 'Collection Items', params: {slug: collection.uid}}">
                <span>Nr {{collection.data['collection.number'].value}} {{collection.data['collection.title'].value[0].text}}</span>
              </router-link>    
            </li>
          </ul>
        </li>
        <li><router-link :to="{name: 'Collections'}"><span>Collections</span></router-link></li>
        <li class="is-hidden-mobile"></li>
        <li><router-link :to="navLinkRt('site.nav--right-link')"><span>Information</span></router-link></li>
        <li><router-link :to="navLinkRt('site.nav--contact-page')"><span>Contact</span></router-link></li>
        <!--<a v-if="$route.params.slug === 'info'" @click="closePage">Close</a>-->
      </ul>
    </transition>
    <!-- tagline -->
    <transition name="fadeinplace">
      <router-link :to="{name: 'Intro'}" class="tagline century-mono vcenter-content" v-show="taglineVisible">
        <span class="vcenter">
          Contemporary Products,
          Traditional Craftsmanship,<br> 
          Designed and Conceived in London
        </span>
      </router-link>
    </transition>
  </nav>
</template>

<script>
import Logo from './LogoMarque'
export default {
  name: 'AppNav',
  props: ['site', 'window', 'collections'],
  components: {
    Logo
  },
  data () {
    return {
      firstPage: true,
      navCondensed: false,
      mobileNavVisible: false,
      taglineVisible: false,
      collectionsVisible: false
    }
  },
  computed: {
    iconVisibile () {
      return !(this.firstPage && this.$route.name === 'Page')
    }
  },
  watch: {
    '$route' () {
      this.firstPage = false // possibly could end up back on first page but...
      this.mobileNavVisible = false
      this.collectionsVisible = false
    },
    mobileNavVisible (visible) {
      if (!visible) this.collectionsVisible = false
    }
  },
  methods: {
    navLinkRt (key) {
      if (!this.site) return '/'
      const link = this.site.data[key]
      if (link.value.document.type === 'page') return {name: 'Page', params: {slug: link.value.document.uid}}
      return '/'
    },
    onScroll () {
      const pageY = window.pageYOffset
      this.navCondensed = pageY > 25
    },
    iconClick () {
      // close icon
      if (this.$route.name === 'Page') {
        this.$router.back()
      // menu icon
      } else {
        this.navCondensed = !this.navCondensed
      }
    },
    closePage () {
      if (this.firstPage) {
        this.$router.push({name: 'Intro'})
      } else {
        this.$router.back()
      }
    }
  },
  created () {
    window.addEventListener('scroll', this.onScroll)
  },
  destroyed () {
    window.removeEventListener('scroll', this.onScroll)
  }
}
</script>

<style lang="scss">
@import '../style/variables';

#nav{
  position: fixed;
  z-index:$z-nav;
  // transtion
  @include transition(
    color $transition-fade, 
    background-color $transition-fade .15s, 
    padding-bottom $transition-nav-size
  );
  .app:not([data-route="Page"]) &{
    transition: background-color $transition-fade 0s,
  }
  // theme
  background-color:inherit;
  @include above_mobile_nav () {
    #app[data-route="Intro"] &,
    #app[data-route="Notes"] & {
      color:$white;
      stroke: $white;
      background: transparent;
      transition: color $transition-fade, background-color 0s;
    }
  }

  a{
    @include transition(
      font-size $transition-nav-size, 
      margin-top $transition-nav-size, 
      background-color $transition-nav-size
    );
  }

  .home-link {
    display:block;
  }

  // tagline
  .tagline{
    visibility:hidden;
    line-height:normal;
    overflow:hidden;
    @media (min-width:$bkpt-mobile + 1) {
      visibility:visible;
      display:block;
      position:absolute;
      top:0; left:0;
      width:100%;
      padding:0 $gutter;
      margin:0;
      background-color:inherit;
      z-index:10;
    }
  }

  // expand / condensed
  // background-color: $white;
  .home-link{
    // @include transition(font-size 0s, opacity $transition-fade .2s, visiblity $transition-fade 0s);
  }

  @include on_mobile_nav() {
    position:absolute;
    // background:$white !important;
  }
}

.nav{
  position:absolute;
  top:0;
  left:0;
  width:100%;
  height:em(59px);
  text-transform: uppercase;
  @include h7();
  transition:max-height 100ms;
  // line-height:0.8;

  span{
    display: inline-block;
    transition:font-size 100ms;
  }

  &.condensed{
    @media (min-width:$bkpt-mobile-nav+1){
      max-height:em(40px);
      span{
        @include h9();
        transform:translateY(-.3em);
      }
    }
  }
  
  > *{
    position: absolute;
    display: block;
    width:100%;
    height:100%;
    top:0;
    left:0;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .nav__mobile-header{
    display:none;
  }

  // home link
  .home-link-outer{
    position: absolute;
    top:0; left:0;
    width:100%; height:100%;
    display: flex; align-items: center; justify-content: center;
  }
  .home-link{
    padding:.5rem;
    svg{
      display:block;
      height:$logoHeight;
      stroke-width:1px;
      overflow:visible;
    }
  }

  // page links
  > ul{
    position: relative;
    padding:0 $gutter;
    display: flex;
    justify-content: space-between;
    align-items: center;
    > li{
      // width:25%;
      position: relative;
      > button{
        position: relative;
        z-index:10;
      }
      > ul{
        position: absolute;
        top:0; left:0;
        padding:calc(1em + #{em(24px)}) 0 1em;
        width:calc(40vw - #{$gutter} * 2);
        opacity:0;
        visibility:hidden;
        transition: opacity 300ms, visibility 0s 300ms;
        text-align:left;
      }
      .no-touchevents & {
        &:hover > ul{
          opacity:1;
          visibility: visible;
          transition: opacity 300ms, visibility 0s 0s;
        }
      }
      .touchevents & > ul.submenu--visible {
        opacity:1;
        visibility: visible;
        transition: opacity 300ms, visibility 0s 0s;
      }
    }
  }
}

// Mobile Layout
@include on_mobile_nav() {
  .nav {
    // color:$black !important;
    // background:$white !important;
    // stroke:$black !important;
    background-color:inherit;
    height:auto;

    > * {
      position: static;
    }

    .nav__mobile-header{
      display:flex;
      // border-bottom-style: solid;
      height:$mobileNavHeight;
      min-height:3em;
      > button{
        display: block;
        position: absolute;
        left:0; top:0;
        height:$mobileNavHeight;
        min-height:3em;
        padding:0 $gutter;
      }
    }

    .submenu-toggle--hidden{
      display:none;
    }

    .home-link-outer{
      display:none;
    }

    // page links
    > ul {
      background:inherit;
      display: block;
      padding:0;
      border-bottom-style: solid;
      &.nav__pages--hidden{
        display:none;
      }
      li{
        background:inherit;
        border-top-style:solid;
        > * {
          height:$mobileNavHeight;
          min-height:3em;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        > button{
          width:100%;
          align-self:stretch;
        }
        > ul {
          min-height:none;
          height:auto;
          background:inherit;
          position: static;
          text-align: center;
          width:100%;
          padding:0;
          top:auto;
          display:none;
          opacity:1;
          visibility: visible;
          filter:invert(100%);
          > li:first-child{
            border-top: none;
          }
          &.submenu--visible{
            display:block;
          }
        }
      }     
    }
  }
}
</style>



// WEBPACK FOOTER //
// Nav.vue?dfc8bf26